import { render } from "./ChatbotTabs.vue?vue&type=template&id=f89ff59c"
import script from "./ChatbotTabs.vue?vue&type=script&lang=js"
export * from "./ChatbotTabs.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__